import { observer } from 'mobx-react-lite'
import React from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { DS } from '../../../../design-system'
import { useStore } from '../../../../models'
import { fontFamily } from '../../../../theme'
import { palette } from '../../../../theme/palette'
import { Card } from '../../Card'
import { WalkthroughOverlayActions } from '../WalkthroughOverlayActions'
import CardGroups from './CardsBackground'

const isWeb = Platform.OS === 'web'

export const DealTheFlop = observer(() => {
  const {
    game: { isFirstStep, isLastStep },
    session: { selectedDailyTask, updateDailyTaskStatus }
  } = useStore()

  const markRaiseOrFoldTaskAsComplete = React.useCallback(async () => {
    try {
      if (selectedDailyTask) await updateDailyTaskStatus()
    } catch (error) {
      console.log('markRaiseOrFoldTaskAsComplete error', error)
    }
  }, [selectedDailyTask, updateDailyTaskStatus])

  React.useEffect(() => {
    return () => {
      console.log('Unmounting deal the flop')
      markRaiseOrFoldTaskAsComplete()
    }
  }, [markRaiseOrFoldTaskAsComplete])

  const Content = isLastStep ? DealTheFlopFinalScreen : isFirstStep ? DealTheFlopFirstScreen : null

  if (!Content) return null

  return (
    <SafeAreaView>
      <View style={styles.container}>
        <Content />
      </View>
    </SafeAreaView>
  )
})

const DealTheFlopFirstScreen = () => {
  return (
    <>
      <View style={styles.cardsBackground}>
        <CardGroups left />
        <CardGroups right />
      </View>
      <View style={[styles.content, isWeb ? { paddingHorizontal: 150 } : undefined]}>
        <View style={styles.cardsContainer}>
          <Card card="Jc" fontSize={30} rotateDegrees="6deg" shadow />
          <Card card="Ks" fontSize={30} rotateDegrees="-6deg" shadow />
        </View>
        <DS.Text variant="Heading 1/Medium" color="Global/White" textAlign="center">
          Deal the Flop
        </DS.Text>
        {/* <Text style={[styles.text, styles.subtitle]}>Deal the Flop subtitle</Text> */}
        <DS.Text variant="Body Medium/Regular" color="Global/White" textAlign="center">
          Test your ability to assess the winner after the Flop (first three community cards) is revealed. You'll
          sharpen your understanding of hand strengths and strategic thinking.
        </DS.Text>
      </View>
      <WalkthroughOverlayActions />
    </>
  )
}

const DealTheFlopFinalScreen = () => {
  return (
    <>
      <View style={styles.content}>
        <View style={styles.cardsContainer}>
          <Card card="Jc" fontSize={30} rotateDegrees="6deg" shadow />
          <Card card="Ks" fontSize={30} rotateDegrees="-6deg" shadow />
        </View>
        <DS.Text variant={'Heading 2/Medium'} textAlign="center" color={'Global/White'} style={{ lineHeight: 33.6 }}>
          Play again?
        </DS.Text>
      </View>
      <WalkthroughOverlayActions />
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    gap: 15,
    padding: 20,
    height: '100%'
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: -120
  },
  text: {
    color: palette.white,
    textAlign: 'center'
  },
  subtitle: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontSize: 18
  },
  cardsBackground: {
    flexDirection: 'row',
    width: '100%',
    position: 'absolute',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    top: 10
  }
})
